import { useState, FC } from 'react'
import { faqSerializedType } from '@components/CMS/FAQ/types'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { MDXRemote } from 'next-mdx-remote'

const Question: FC<faqSerializedType> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <div key={question} className="pt-6">
      <>
        <dt>
          <button
            className="flex w-full items-start justify-between text-left text-gray-900"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="text-base font-semibold leading-7">
              {question}
            </span>
            <span className="ml-6 flex h-7 items-center">
              {isOpen ? (
                <AiOutlineMinus className="h-6 w-6" aria-hidden="true" />
              ) : (
                <AiOutlinePlus className="h-6 w-6" aria-hidden="true" />
              )}
            </span>
          </button>
        </dt>
        {isOpen ? (
          <div className="mt-2 pr-12">
            <p className="text-base leading-7 text-gray-600 prose">
              <MDXRemote {...answer} />
            </p>
          </div>
        ) : (
          <></>
        )}
      </>
    </div>
  )
}
export default Question
